module.exports = __webpack_public_path__ + "img/p17.4a621959.png";